<template lang="html">
  <div class="cover van-hairline--bottom">
    <van-skeleton
      title
      title-width="70%"
      avatar
      avatar-shape="square"
      avatar-size="80px"
      :row="2"
      :loading="loading"
    >
      <van-row type="flex">
        <van-col span="7">
          <img :src="cover" class="cover-img">
        </van-col>
        <van-col span="16" offset="1" class="info">
          <ul>
            <li class="item" v-if="premium"><van-tag plain type="danger">私房课</van-tag></li>
            <li class="item" v-if="hasAudios"><van-tag plain type="primary">音频</van-tag></li>
            <li class="item" v-if="hasVideos"><van-tag plain type="primary">视频</van-tag></li>
          </ul>
          <h1>{{title}}</h1>
          <span class="meta">
            {{duration}}
            <span class="saparator">|</span>
            {{datetime}}
          </span>
        </van-col>
      </van-row>
    </van-skeleton>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Skeleton } from 'vant'
  import { Row, Col } from 'vant'
  import { Tag } from 'vant'
  import {humanDuration, humanDateTime} from '../utils/time.js'

  Vue.use(Skeleton)
  Vue.use(Row).use(Col)
  Vue.use(Tag)

  export default {
    data () {
      return {
        loading: true,
        cover: '',
      }
    },
    props: {
      coverId: Number,
      title: String,
      seconds: Number,
      created: Number,
      premium: Boolean,
      hasAudios: Boolean,
      hasVideos: Boolean
    },
    computed: {
      duration () {
        return humanDuration(this.seconds)
      },
      datetime () {
        return humanDateTime(this.created)
      }
    },
    methods: {

    },
    watch: {
      coverId: function (val) {
        let that = this
        that.$api.image.detail(val).then(res => {
          window.console.log(res)
          // that.cover = res.data.upload
          that.cover = res.data.private_cdns[0].cdn_url
          that.loading = false
        })
      }
    },
    mounted () {
    },
}
</script>

<style lang="css" scoped>
  .cover {
    padding: 16px;
    background: #fff;
  }

  .shadow {
    box-shadow: 0px 0px 4px #666;
  }

  h1 {
    padding: 0;
    margin: 10px 0 0 0;
    font-size: 1.1em;
  }

  .info {
    /* height:100px; */
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .meta {
    display: block;
    padding: 0;
    margin-top:10px;
    font-size: 0.9rem;
    color: #999;
  }

  .saparator {
    margin: 0 5px;
    color: #ccc;
  }

  li.item {
    margin-right: 5px;
    display: inline;
  }

  .cover-img {
    width: 100%;
    border-radius:5px;
  }
</style>
